import type { OverlayTarget } from '../types/research';
import { getResearchEdge } from './bestEdge';

/**
 * Single construction site for `OverlayTarget`. Derives `edge` (row's best
 * line, kept un-gated so analysis panels can still anchor when nothing is
 * +EV) from `bestLines`; everything else — including `clickedBook` — passes
 * through verbatim.
 *
 * Why this helper still earns its keep after the cell-threading shrink:
 * `edge` is required by multiple panels (chart, calculator, research) and
 * a forgotten edge derivation in one click path was the original
 * "May 2026 missing link" bug. One construction site keeps the rule honest.
 */
export type BuildOverlayTargetArgs = Omit<OverlayTarget, 'edge' | 'marketLine'>;

export function buildOverlayTarget(args: BuildOverlayTargetArgs): OverlayTarget {
  return {
    ...args,
    marketLine: args.bestLines?.over?.line ?? args.bestLines?.under?.line ?? null,
    edge: getResearchEdge(args.bestLines),
  };
}
